class MainSearch extends SearchForm {
  constructor() {
    super();
    this.prependQuery = this.dataset.prependQuery;
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();

    if (this.prependQuery) {
      this.stripBrandQueryFromInput();
    }
  }

  setupEventListeners() {
    const form = this.input?.form;

    if (form) {
      if (this.prependQuery) {
        form.addEventListener('submit', this.onFormSubmit.bind(this));
      }
      form.addEventListener('reset', this.onFormReset.bind(this));
    }

    this.input?.addEventListener('focus', this.onInputFocus.bind(this));

    if (this.allSearchInputs.length < 2) return;

    this.allSearchInputs.forEach(input =>
      input.addEventListener('input', this.onInput.bind(this))
    );
  }

  getBrandQuery(searchTerm = this.input.value) {
    const term = searchTerm.trim();
    if (!term || !this.prependQuery) return term;
    return `${this.prependQuery} ${term}`;
  }

  stripBrandQuery(searchTerm) {
    const term = searchTerm.trim();
    if (!term || !this.prependQuery) return term;

    const prefix = `${this.prependQuery} `;
    if (term === this.prependQuery) return '';
    if (term.startsWith(prefix)) return term.slice(prefix.length).trim();
    return term;
  }

  stripBrandQueryFromInput() {
    const displayQuery = this.stripBrandQuery(this.input.value);
    if (displayQuery !== this.input.value) {
      this.input.value = displayQuery;
    }
  }

  onFormSubmit(event) {
    if (!this.prependQuery) return;

    const displayTerm = this.input.value.trim();

    if (!displayTerm) {
      event.preventDefault();
      return;
    }

    event.preventDefault();

    const form = this.input.form;
    const params = new URLSearchParams(new FormData(form));
    params.set('q', this.getBrandQuery(displayTerm));
    window.location.assign(`${form.action}?${params.toString()}`);
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({behavior: 'smooth'});
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach(input => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
